import React from "react";
import { Route, Redirect } from "react-router-dom";
import authenticationService from '../services/authentication.service';
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : PrivateRouteLogin
Description : Pagina de PrivateRouteLogin para permitir acceso a las paginas si el loguin esta correcto.
Date Autor Modification
================================================================================
2/11/2021 Cristian Andres Pizo Mina - Pagina de PrivateRouteLogin.
================================================================================ */
export function PrivateRouteLogin({ component, ...options }) {

    const autenticado = authenticationService.getAuthUser();
    let hasDashboard = true
    let hasPerson = true
    try{
        const options_ = JSON.parse(localStorage.getItem("options_web"))
        hasDashboard = options_.some(opt => opt.items.some(item => item.route === '/Dashboard' || (item.items && item.items.some(subitem => subitem.route === '/Dashboard'))))
        hasPerson = options_.some(opt => opt.items.some(item => item.route === '/CreatePerson' || (item.items && item.items.some(subitem => subitem.route === '/CreatePerson'))))
    }
    catch(error){
        console.log("Not ready yet: ", error)
    }
    console.log(autenticado)
    return (
        autenticado.token && autenticado.type === "APPROVER" && hasDashboard
            ? <Redirect to="/Dashboard" />
            : (autenticado.token && autenticado.type === "CLIENT" && hasPerson ? <Redirect to="/CreatePerson" /> : 
             autenticado.token ? <Redirect to="Welcome"/> : <Route {...options} component={component} />)
    )
};


export default PrivateRouteLogin;
